// extracted by mini-css-extract-plugin
module.exports = {"Scouting":"styles_Scouting__2kfrf","fadeIn":"styles_fadeIn__1P3-d"};